/** Raw Amplify auth user from getCurrentAuthenticatedUser */
interface AmplifyAuthUser {
  attributes: { sub: string };
  signInUserSession: {
    accessToken: { jwtToken: string };
  };
}

/** Raw DynamoDB user details from /myself */
interface RawUserDetails {
  image?: { S: string };
  firstname?: { S: string };
  lastname?: { S: string };
  email?: { S: string };
}

export function transformAuthUser(amplifyAuthUser: AmplifyAuthUser | null) {
  if (!amplifyAuthUser) return null;
  const {
    attributes: { sub },
    signInUserSession: {
      accessToken: { jwtToken },
    },
  } = amplifyAuthUser;
  return { uid: sub, jwtToken };
}

export function transformUserDetails(myself: RawUserDetails | null) {
  if (!myself) return null;
  return {
    image: myself.image?.S,
    firstname: myself.firstname?.S,
    lastname: myself.lastname?.S,
    email: myself.email?.S,
  };
}
